import { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:5001";

export default function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done | error
  const [message, setMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("sending");
    setMessage("");
    try {
      const res = await fetch(`${API_URL}/subscribers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const payload = await res.json().catch(() => null);
      if (!res.ok) {
        setState("error");
        setMessage(
          payload?.error === "invalid_email"
            ? "Please enter a valid email."
            : "Something went wrong. Try again."
        );
        return;
      }
      setState("done");
      setMessage("You're subscribed. Thanks!");
      setEmail("");
    } catch {
      setState("error");
      setMessage("Network error. Try again.");
    }
  };

  return (
    <div id="subscribe">
      <form className="ft-form" onSubmit={onSubmit}>
        <input
          className="ft-input"
          type="email"
          placeholder="your@email.com"
          aria-label="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={state === "sending" || state === "done"}
          required
        />
        <button
          className="ft-btn"
          type="submit"
          disabled={state === "sending" || state === "done"}
        >
          {state === "sending" ? "…" : state === "done" ? "✓" : "Subscribe"}
        </button>
      </form>
      {message ? (
        <p
          className="ft-legal-note"
          style={{ color: state === "error" ? "#fca5a5" : "#9ca3af" }}
        >
          {message}
        </p>
      ) : (
        <p className="ft-legal-note">No spam. Unsubscribe anytime.</p>
      )}
    </div>
  );
}
